import { render, staticRenderFns } from "./SalesChannels.vue?vue&type=template&id=48a804fc"
import script from "./SalesChannels.vue?vue&type=script&lang=js"
export * from "./SalesChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports